import { get, post } from '@utils/request';

const preview = 'address/';

export const login = data => post(`${preview}queryAddress`, data);

export const getAddressDetail = params => get(`${preview}queryAddress`, params);

export const getAddressList = params => get(`${preview}queryAddressList`, params);

export const saveAddress = data => post(`${preview}saveAddress`, data);

export const updateAddress = data => post(`${preview}updateAddress`, data);

export const queryAreaList = params => get(`${preview}queryAreaList`, params);

export const getUserDefaultAddress = params => get('shop/order/determinePay', params);

export const deleteAddressItem = params => get(`${preview}delAddress`, params);
